export default __webpack_public_path__ + "static/media/visitsWhite.3c02bc38.png";